"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLoaderSpinner = _interopRequireDefault(require("react-loader-spinner"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Loading page component
 * @param {('Audio','BallTriangle','Bars','Circles','Grid','Hearts','Oval','Puff','Rings','TailSpin','ThreeDots','Watch','RevolvingDot','Triangle','Plane','MutatingDots','CradleLoader'|null)} typeSpin
 * @param {String=} spinColor
 *
 */

var LoadingHeader = function LoadingHeader(_ref) {
  var typeSpin = _ref.typeSpin,
    spinColor = _ref.spinColor;
  return /*#__PURE__*/_react.default.createElement(_styled.Container, null, /*#__PURE__*/_react.default.createElement(_reactLoaderSpinner.default, {
    type: typeSpin,
    color: spinColor,
    height: 70,
    width: 70,
    timeout: 2000
  }));
};
LoadingHeader.propTypes = {
  spinColor: _propTypes.default.string,
  typeSpin: _propTypes.default.string
};
LoadingHeader.defaultProps = {
  spinColor: '#CB3DC5',
  typeSpin: 'ThreeDots'
};
var _default = LoadingHeader;
exports.default = _default;